

export enum Language {
  ESPANISH = "es",
  ENGLISH = "en",
  FRENCH = "fr",
}

export enum CommonContentType {
  BLUE_CARD_ANSWER = "answers_blue_cards",
  RED_CARD_ANSWER = "answers_red_cards",
  GENERI_CBUTTONS = "generic_buttons",
  GENERIC_CONTENT = "generic_content",
  QUOTES_AUTHORS = "quotes_authors",
  TRANSLATABLE_IMAGES = "translatable_images",
}

export enum ButtonTypes {
  ACCEPT = "ACCEPT",
  BACK = "BACK",
  CANCEL = "CANCEL",
  CONTINUE = "CONTINUE",
  GET_INTO = "GET_INTO",
  KEEP_PLAYING = "KEEP_PLAYING",
  MORE_INFO = "MORE_INFO",
  PLAY_ALONE = "PLAY_ALONE",
  SEND_ANSWER = "SEND_ANSWER",
  START_GAME = "START_GAME",
  START_PALYING = "START_PALYING",
  THROW_THE_DICE = "THROW_THE_DICE",
  RATING_LABEL ='RATING_LABEL',
}

export enum ContentKey {
  ANONYMOUS_LOGIN = "ANONYMOUS_LOGIN",
  ARRIVAL_POSITIONS = "ARRIVAL_POSITIONS",
  BOARD_POSITIONS = "BOARD_POSITIONS",
  COUNTRY = "COUNTRY",
  CREATE_PROFILE = "CREATE_PROFILE",
  CREATE_PROFILE_DESCRIPTION = "CREATE_PROFILE_DESCRIPTION",
  CONTENT_CIPIED = "CONTENT_C0PIED",
  COPY_GAME_LINK = "COPY_GAME_LINK",
  END_OF_GAME = "END_OF_GAME",
  ENGLISH = "ENGLISH",
  EVALUATE_ANSWER = "EVALUATE_ANSWER",
  EXIT_BOARD = "EXIT_BOARD",
  EXCELLENT_LABEL = "EXCELLENT_LABEL",
  FACEBOOK_LOGIN = "FACEBOOK_LOGIN",
  FALSE_LABEL='FALSE_LABEL',
  FINAL_EVALUATION = "FINAL_EVALUATION",
  FRENCH = "FRENCH",
  GAME_INSTRUCTIONS = "GAME_INSTRUCTIONS",
  GAME_MODE_DESCRIPTION = "GAME_MODE_DESCRIPTION",
  GAME_HAS_REACHED_MAX_PLAYERS = "GAME_HAS_REACHED_MAX_PLAYERS",
  GLOBAL_RANKING = "GLOBAL_RANKING",
  GOOD_LABEL = "GOOD_LABEL",
  HELP = "HELP",
  HINT_LABEL = "HINT_LABEL",
  HOW_TO_PLAY = "HOW_TO_PLAY",
  IMAGE = "IMAGE",
  INVITE_PLAYERS = "INVITE_PLAYERS",
  INVITE_PLAYERS_DESCRIPTION = "INVITE_PLAYERS_DESCRIPTION",
  LEAVE_GAME = "LEAVE_GAME",
  LEAVE_GAME_CONFIRMATION = "LEAVE_GAME_CONFIRMATION",
  LINK = "LINK",
  LOG_OUT = "LOG_OUT",
  MENU = "MENU",
  MY_PROFILE = "MY_PROFILE",
  NAME = "NAME",
  OK_LABEL = "OK_LABEL",
  PLAY_ALONE = "PLAY_ALONE",
  PLAY_WITH_FRIENDS = "PLAY_WITH_FRIENDS",
  PLEASE_WAIT = "PLEASE_WAIT",
  PREFERENCES = "PREFERENCES",
  PRIVACY_POLICY = "PRIVACY_POLICY",
  PROJECT_DEVELOPER = "PROJECT_DEVELOPER",
  PROJECT_SPONSOR = "PROJECT_ SPONSOR",
  IN_ALLIANCE_WITH = "IN_ALLIANCE_WITH",
  RIGHT_ANSWER = "RIGHT_ANSWER",
  SEND_ANSWER_LABEL="SEND_ANSWER_LABEL",
  SCORE = "SCORE",
  SETTINGS = "SETTINGS",
  SELECT_LANGUAGE = "SELECT_LANGUAGE",
  SPANISH = "SPANISH",
  STAR_FIVE = "STAR_FIVE",
  STAR_FOUR = "STAR_FOUR",
  STAR_ONE = "STAR_ONE",
  STAR_THREE = "STAR_THREE",
  STAR_TWO = "STAR_TWO",
  START_GAME_DESCRIPTION = "START_GAME_DESCRIPTION",
  START_GAME_DESCRIPTION_USER_INVITED = "START_GAME_DESCRIPTION_USER_INVITED",
  USER_HAS_LEFT_GAME="USER_HAS_LEFT_GAME",
  TIME_OUT = "TIME_OUT",
  TRUE_LABEL='TRUE_LABEL',
  USELESS_LABEL = "USELESS_LABEL",
  USER_HAS_CONNECTED = "USER_HAS_CONNECTED",
  POOR_LABEL = "POOR_LABEL",
  GAME_INVITE = "GAME_INVITE",
  WELCOME = "WELCOME",
  WRONG_ANSWER = "WRONG_ANSWER",
  YOUR_TURN_TO_PLAY = "YOUR_TURN_TO_PLAY",
  RATING_WAITING_LABEL ='RATING_WAITING_LABEL',
  RATING_PLAYERS_LABEL ='RATING_PLAYERS_LABEL',
  RATING_FINISHED_LABEL ='RATING_FINISHED_LABEL'
}


export enum TranslatableImagesTypes {
  OWNER_LOGO = "OWNER_LOGO",
  IN_ALLIANCE_WITH = "IN_ALLIANCE_WITH",
  SPONSORS = "SPONSORS",
}

export enum ContentType {
  BLUE_CARDS = "blue_cards",
  HOW_TO_PLAY_SLIDER = "how_to_play_slider",
  GREEN_CARDS = "green_cards",
  YELLOW_CARDS = "yellow_cards",
  RED_CARDS = "tarjetas_rojas",
  TERMS_AND_CONDITIONS = "terms_and_conditions",
  GAME_INSTRUCTIONS = "game_instructions",
}
export enum QuestionType {
  TRUE_FALSE = "true_false",
  MULTIPLE_OPTIONS = "multiple_options",
}

export type Content = {
  id: string;
  lang: string;
  hiddenAnswer: string;
  media: string;
  cardAnswer: null | string;
  body: string;
  cardAnswers: null | string[];
  cardImage: string;
  moreInfo: string;
  questionType: null | QuestionType;
  authorQuote: null | string;
  rightCardAnswer: null | string;
  questionSituation: null | string;
  timeOut: null | string;
  type: ContentType;
  answerHint: null | string;
  description: null | string;
  title: string;
  moreInfoLabel: string;
  order?: number;
};

export type CommonContent = {
  name: string;
  buttonLabel: ButtonTypes;
  contentKey: ContentKey;
  id: string;
  lang: string;
  description: false;
  type: CommonContentType;
  imageKey: TranslatableImagesTypes;
  image: string;
};

export type CardQuestion = {
  id: string;
  label: string;
};

export type RatingLabels = {
  useless: string;
  poor: string;
  ok: string;
  good: string;
  excellent: string;
};
